import React from 'react';
import { bool, object, shape, string } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import { shouldRenderCustomOrder } from '../../common/customOrder';
import { isBuyerEligibleForMTPromotion } from '../../utils/sellerLanguage';
import { inExperiment } from '../../utils/experiments';
import { LIONS_CONTACT_SELLER_MT_PROMOTION } from '../../utils/experiments/experimentsEnum';
import ContactSellerMTPromotion from './ContactSellerMTPromotion';
import { MP_SOURCE_COMPONENT, BQ_SOURCE_NAME } from './constants';
import ContactSellerOptions from './ContactSellerOptions';
import ContactSellerBtn from './ContactSellerBtn';

import './style.scss';

const ContactSeller = ({ customOrder }, { general, businessLayout, seller }) => {
    const { userId, abTests, locale, browserLanguage, countryCode } = getContext();
    const { proficientLanguages } = seller;
    const customOrderEligible = shouldRenderCustomOrder({
        userId,
        customOrder,
        general
    });
    const titleSuffix = businessLayout ? 'contact_seller_options.business_title' : 'contact_seller.title';
    const titleCopy = `gig_page_perseus.${titleSuffix}`;
    const showMachineTranslationPromotion = inExperiment(LIONS_CONTACT_SELLER_MT_PROMOTION, abTests) &&
    isBuyerEligibleForMTPromotion({
        proficientLanguages,
        locale,
        browserLanguage,
        userId,
        sellerId: general.sellerId,
        isStudio: general.isStudio,
        isBusiness: businessLayout,
        countryCode
    });

    return (
        <div className="contact-seller">
            {customOrderEligible && <ContactSellerOptions/>}
            {!customOrderEligible &&
                <ContactSellerBtn titleKey={titleCopy}
                    mixpanelSourceComponent={MP_SOURCE_COMPONENT}
                    bqSourceName={BQ_SOURCE_NAME}/>
            }
            {showMachineTranslationPromotion && <ContactSellerMTPromotion/>}
        </div>
    );
};

ContactSeller.propTypes = {
    customOrder: shape({
        currentUserStatus: string,
        allowCustomOrders: bool
    })
};

ContactSeller.defaultProps = {
    customOrder: {
        allowCustomOrders: true
    }
};

ContactSeller.contextTypes = {
    general: object,
    businessLayout: bool,
    seller: object
};

export { ContactSeller };
export default SafePureComponent(ContactSeller);
